'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
require('medium-editor/dist/css/medium-editor.css');
require('medium-editor/dist/css/themes/bootstrap.css');
var _reactMediumEditor = require('react-medium-editor');
var _reactMediumEditor2 = _interopRequireDefault(_reactMediumEditor);
var _ResponsiveModes = require('../../constants/ResponsiveModes');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var styles = {
  Text: {
    minHeight: 'initial',
    margin: 0,
    outline: 0,
    fontSize: function fontSize(_ref) {
      var responsiveMode = _ref.responsiveMode,
        _fontSize = _ref.cssProperties.fontSize,
        mobileFontSize = _ref.otherProperties.mobileFontSize;
      return responsiveMode === _ResponsiveModes.MOBILE ? mobileFontSize : _fontSize;
    },
    '& p, & h1, & h2, & h3, & blockquote, & ul': {
      marginTop: 0,
      marginBottom: 0,
      wordWrap: 'break-word'
    },
    '& a': {
      textDecoration: 'inherit',
      color: function color(_ref2) {
        var otherProperties = _ref2.otherProperties;
        return otherProperties.linkColor || 'inherit';
      }
    }
  }
};
var Text = function (_Component) {
  _inherits(Text, _Component);
  function Text() {
    _classCallCheck(this, Text);
    return _possibleConstructorReturn(this, (Text.__proto__ || Object.getPrototypeOf(Text)).apply(this, arguments));
  }
  _createClass(Text, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return JSON.stringify(this.props) !== JSON.stringify(nextProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
        classes = _props.classes,
        _props$cssProperties = _props.cssProperties,
        fontSize = _props$cssProperties.fontSize,
        cssProperties = _objectWithoutProperties(_props$cssProperties, ['fontSize']),
        value = _props.value,
        editable = _props.editable,
        onChangeText = _props.onChangeText;
      var options = {
        targetBlank: true,
        anchor: {
          linkValidation: true
        },
        buttonLabels: 'fontawesome',
        toolbar: {
          buttons: ['bold', 'italic', 'underline', {
            name: 'anchor'
          }, 'quote', 'h1', 'h2', 'unorderedlist']
        }
      };
      return editable ? _react2.default.createElement(_reactMediumEditor2.default, {
        className: classes.Text,
        text: value,
        options: options,
        onChange: onChangeText,
        style: cssProperties
      }) : _react2.default.createElement('div', {
        className: classes.Text,
        dangerouslySetInnerHTML: {
          __html: value
        },
        style: cssProperties
      });
    }
  }]);
  return Text;
}(_react.Component);
exports.default = (0, _reactJss2.default)(styles)(Text);